module.exports = __webpack_public_path__ + "img/mobile.cf4a3006.svg";